import { lazy, Suspense } from 'react'
import { LoadingCaption, Section, Shell } from './ScreenShell'

// three / fiber / drei load with this chunk only, on the first visit to the screen.
const Warehouse3DScreen = lazy(() => import('./Warehouse3DScreen'))

const Warehouse3D = () => (
    <Suspense
        fallback={
            // The screen's backdrop and loading caption already: the scene comes in over them.
            <Section>
                <Shell $isExpanded={false}>
                    <LoadingCaption isHidden={false} />
                </Shell>
            </Section>
        }
    >
        <Warehouse3DScreen />
    </Suspense>
)

export default Warehouse3D
